import { render, staticRenderFns } from "./device-add.vue?vue&type=template&id=20737fe1&scoped=true&"
import script from "./device-add.vue?vue&type=script&lang=js&"
export * from "./device-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20737fe1",
  null
  
)

export default component.exports